import { render, staticRenderFns } from "./purchase-invoice.vue?vue&type=template&id=62ba1d81&scoped=true"
import script from "./purchase-invoice.vue?vue&type=script&lang=js"
export * from "./purchase-invoice.vue?vue&type=script&lang=js"
import style0 from "./purchase-invoice.vue?vue&type=style&index=0&id=62ba1d81&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62ba1d81",
  null
  
)

export default component.exports